import TEAMS from "./teams.json";

// Flat pool of every player with team context attached (built once).
let POOL = null;
function getPool() {
  if (POOL) return POOL;
  POOL = [];
  for (const t of TEAMS) {
    for (const p of t.players) {
      POOL.push({
        ...p,
        teamId: t.id,
        club: t.club,
        season: t.season,
        fifaEdition: t.fifaEdition,
      });
    }
  }
  return POOL;
}

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// 3 random eligible replacements for a slot — comparable or better than current.
export function transferOffers(slot, currentPlayer, roster, count = 3) {
  const pool = getPool();
  const rosterNames = new Set(Object.values(roster).map((p) => p.name));
  const fitsSlot = (p) => {
    const pos = p.positions?.length ? p.positions : [p.pos];
    return pos.some((x) => slot.accepts.includes(x));
  };
  const minOverall = (currentPlayer?.overall ?? 70) - 2;

  let eligible = pool.filter(
    (p) => !rosterNames.has(p.name) && fitsSlot(p) && p.overall >= minOverall,
  );
  if (eligible.length < count) {
    eligible = pool.filter((p) => !rosterNames.has(p.name) && fitsSlot(p));
  }

  const picked = [];
  const seen = new Set();
  for (const p of shuffle(eligible)) {
    if (seen.has(p.name)) continue;
    seen.add(p.name);
    picked.push(p);
    if (picked.length >= count) break;
  }
  return picked;
}
